<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="SingleReturnMoveModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">在庫移動</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>移動先</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td>
<!--                  <select class="custom-select" v-model="to_warehouse_id">-->
<!--                    <option value="0">-</option>-->
<!--                    <option v-for='(warehouse, i) in warehouses' :value="warehouse.id" :key='`to-${i}`' v-on:click='to_warehouse_id=warehouse.id;'>{{ warehouse.name }}</option>-->
<!--                  </select>-->
                  <v-select class="v-select-wd100" :options="warehouses" label="name" value="id" v-model="to_warehouse"></v-select>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped table-align-middle">
            <thead>
            <tr>
              <th>移動日</th>
            </tr>
            </thead>
            <tbody class="nowrap">
            <tr>
              <td>
                <input v-model="referenceAt" type="date" class="form-control" @focus="tempDateField = referenceAt">
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
          <button type="button" class="btn btn-primary" @click="moveWarehouse()">更新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'SingleReturnMoveModal',
  components: {
    VueElementLoading
  },
  props: {
    isConsignment: null,
    warehouses: null,
    warehouse: null,
    detail: null
  },
  data () {
    return {
      to_warehouse: {},
      isSearching: false,
      referenceAt: null,
      tempDateField: null
    }
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.setInitialData)
  },
  methods: {
    setInitialData () {
      this.to_warehouse = this.warehouses.find((item) => item.id === Number(this.detail.to_warehouse_id))
      this.referenceAt = this.detail.shipped_at || this.$invoiceTools.getCurrentDate()
    },

    async moveWarehouse () {
      if (this.to_warehouse.id === 0) {
        this.$toastr.warning('移動先を選択してください')
        return
      }

      this.$dialog.confirm('在庫を移動しますか?').then(async () => {
        this.isSearching = true
        try {
          let params = {
            return_detail_id: this.detail.id,
            to_warehouse_id: this.to_warehouse.id,
            reference_at: this.referenceAt
          }

          let response = null
          if (!this.isConsignment) {
            response = await this.$http.post(this.$api_url.return_move_to_stock, params)
          } else {
            response = await this.$http.post(this.$api_url.consignment_return_move_to_stock, params)
          }
          // let $data = this.$invoiceTools.prepareResult(result.data, '', 'SingleReturn:moveStock')
          const result = response.data
          if (result.status === true) {
            this.$toastr.success('在庫移動に成功しました。', 'Success')
            this.detail.to_warehouse_id = this.to_warehouse.id
            this.detail.is_moved = 1
            const btn = this.$refs.closeModal
            btn.click()
          } else {
            this.$toastr.error(result.message, 'エラー')
          }
          this.isSearching = false
        } catch (error) {
          this.isSearching = false
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    }
  }
}
</script>
